angular.module('dpw.components')
    .factory('PaginationSimple', function () {
        /**
         * @constructor PaginationSimpleFactory
         * @param {Object} options
         * @param {Number} options.page
         * @param {Number} options.size
         * @param {Number} options.total
         * @param {Function} options.onChange
         */
        return function PaginationSimpleFactory(options) {
            var defaults = {
                page: 1,
                size: 5,
                total: 0
            };
            var state = _.assign(defaults, options);
            var pagination = {
                state: state,
                updateOld: function () {
                    var currentState = state.page * state.size;
                    this.exports.hasOld = state.total - currentState > 0;
                },
                updateNew: function () {
                    this.exports.hasNew = state.page !== 1 &&
                        state.total > state.size;
                },
                update: function () {
                    this.updateOld();
                    this.updateNew();
                },
                page: function (page) {
                    state.page = page;
                    this.update();
                },
                size: function (size) {
                    state.size = size;
                },
                total: function (value) {
                    state.total = value;
                    this.update();
                },
                change: function (page) {
                    var options = {
                        page: page,
                        pagination: this
                    };
                    state.onChange({options: options});
                },

                // Properties export to View.
                exports: {
                    state: state,
                    hasOld: false,
                    hasNew: false,
                    old: function () {
                        if (state.page < state.total / state.size) {
                            state.page++;
                            pagination.change(state.page);
                        }
                    },
                    new: function () {
                        state.page > 1 && state.page--;
                        pagination.change(state.page);
                    }
                }
            };

            return pagination;
        };
    })
    /**
     * @ngdoc component
     * @name dpwPaginationSimple
     * @restrict EA
     * @param {Function} onChange
     * @param {Number} total - Total Items
     * @param {Number} page  - Current Page
     * @param {Number} size  - Page Size
     */
    .directive('dpwPaginationSimple', ['PaginationSimple', function (PaginationSimple) {
        return {
            restrict: 'EA',
            scope: {
                onChange: '&',
                total: '=',
                page: '=',
                size: '='
            },
            templateUrl: 'dpw-pagination-simple.html',
            controller: ['$scope', function ($scope) {
                var ps = new PaginationSimple({
                    page: $scope.page,
                    size: $scope.size,
                    onChange: $scope.onChange
                });

                $scope.$watch('total', function (newValue) {
                    ps.total(newValue);
                });

                $scope.$watch('size', function (newValue) {
                    ps.size(newValue);
                });

                $scope.$watch('page', function (newValue) {
                    ps.page(newValue);
                });

                $scope.pagination = ps.exports;
            }]
        };
    }]);